<template>
  <header class="c-lection-header bg-shadows">
    <div class="container-fluid h-100">
      <div class="d-flex align-items-center justify-content-between h-100">
        <button
          :disabled="!user && !enroll ? true : false"
          class="c-link c-link--white d-flex align-items-center"
          @click="$bvModal.show('modalReview')"
          :data-v-step="(device == 'desktop') ? '4' : ''">
          <i
            class=" d-flex align-items-center me-2"
            :class="rating ? 'iconf-star' : 'iconf-star-empty'"
          ></i>
          <span class="w-medium">Valorar este curso</span>
        </button>
        <div class="d-flex align-items-center">
          <Notifications
            v-if="user && user.id"
            :body="user"
            :device="device"
            class="me-2"
          >
          </Notifications>
          <Profile v-if="user && user.id" :body="user" :device="device"></Profile>
          <a v-else href="/ingresar/" class="c-link">Iniciar sesión</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';

import Profile from '../Profile.vue';
import Notifications from '../Notifications.vue';

export default {
  data() {
    return {
      user: null,
    };
  },
  components: {
    Profile,
    Notifications,
  },
  props: ['device', 'enroll', 'rating'],
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),
  },
  watch: {
    userData(data) {
      this.user = data;
    },
  },
  mounted() {
    this.user = this.userData;
  },
};
</script>
